import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../common/CustomModal';
import CreatePayment from '../CreateForm/CreatePayment';
import UpdatePayment from '../UpdateForm/UpdatePayment';
import { DELETE_IMPORT_PAYMENT_VOUCHER, GET_SUPPLIERS_LIST, LIST_COMMERCIAL_INVOICES_EXPORT, LIST_IMPORT_PAYMENT_VOUCHERS, LIST_PROFORMA_INVOICES_EXPORT } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getCommanExportShipmentId, getCurrencyList, getPartyLedger, getPaymentTocustomer, getPaymentType } from '../../../services/CommonServices';
import PaymentVoucherView from '../ViewDetails/PaymentVoucherView';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";

import axios from 'axios';

export default function PaymentVoucher({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Payment');
    const [paymentToList, setPaymentToList] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [partyLedger, setPartyLedger] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [paymentVoucherId, setPaymentVoucherId] = useState('');
    const [currencyList, setCurrencyList] = useState([]);
    const [paymentType, setPaymentType] = useState([]);
    const [newShippingId, setNewShippingId] = useState(null);
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);

    const navigate = useNavigate();

    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);

    let supplierId, cifFob;

    const hasFetched = useRef(false);

    useEffect(() => {
        if (shipmentDetails) {
            supplierId = shipmentDetails.customerId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            getCommonData();
            getProformaInvoice();
            fetchDataCommercialList();
            getCustomersList();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, paymentVoucherId, token, deleteAlert, modal]);

    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const paymentType = await getPaymentType();
        setPaymentType(paymentType);
        const paymentToList = await getPaymentTocustomer();
        setPaymentToList(paymentToList);
        const partyLedger = await getPartyLedger();
        setPartyLedger(partyLedger);
    }


    const getCustomersList = async () => {
        try {
            const payload = {
                clientCompanyId: supplierId,
            };

            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });

            if (response.data && response.data.success && response.data.clientCompanies) {
                const customersData = response.data.clientCompanies.map((customer) => ({
                    id: customer.clientCompanyId,
                    title: customer.clientCompanyName,
                }));
                setCustomerList(customersData);

            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };

    const fetchDataCommercialList = async () => {
        setLoading(true);
        try {
            const payload = {
                customerNamesId: customerName,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES_EXPORT, payload);
            if (response.data.success) {
                const commercialInvoices = response.data.data.map((invoice, index) => {
                    return {
                        id: invoice.commercialInvExpId || '',
                        title: invoice.commercialInvoiceNo || '',
                    };
                });
                setCommercialInvoiceList(commercialInvoices);
            } else {
                setError('No commercial invoices found');
            }
        } catch (error) {
            setError('Error fetching commercial invoices');
            console.error('Error fetching commercial invoices', error);
        } finally {
            setLoading(false);
        }
    };

    const getProformaInvoice = async () => {
        try {
            const payload = {
                customerNamesId: customerName,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_PROFORMA_INVOICES_EXPORT, payload, {
            });
            if (response.data && response.data.success && response.data.data) {
                const proform = response.data.data.map((invoice) => ({
                    id: invoice.proformaInvExpId || '',
                    title: invoice.proformaInvoiceNo || '',
                    // title: `${expProformaPrefix || ''} ${invoice.proformaInvoiceNo || ''} ${expProformaSuffix || ''}`,
                }));
                setProformaInvoiceList(proform);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching suppliers list:', error);
            return [];
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: supplierId,
                commanShipmentId: getCommanExportShipmentId,
                shipmentId: shipmentId,

            };
            const response = await genericPost(LIST_IMPORT_PAYMENT_VOUCHERS, payload, {
            });
            if (response.data.success && response.data.paymentVoucher) {
                const { newShippingId } = response.data;
                const paymentVoucherData = response.data.paymentVoucher.map((voucher, index) => ({
                    sn: voucher.paymentVoucherId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    date: companyDateFormat(voucher?.date) || '',
                    voucherNo: voucher.paymentVoucherNo || '',
                    supplierName: voucher?.partyLedger?.partyName
                        ? voucher.partyLedger.partyName
                        : voucher.clientCompany?.clientCompanyName || '',
                    paymentToName: voucher?.paymentToData?.paymentToName ?? '',
                    paymentType: voucher.paymentType?.paymentName || '',
                    currency: voucher.currency?.currency || '',
                    baseCurrency: voucher.baseCurrency?.currency || '',
                    amount1: `${voucher?.currency?.currency_symbol || ''} ${voucher.amount || ''}`,
                    amount2: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.amountInBaseCurrency || ''}`,
                    bankCharges: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.bankCharges || ''}`,
                    conversionRate: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.conversionRate || ''}`,
                    paymentTypeColor: voucher.paymentType?.ColorPlate?.color || '',
                    paymentTypeBgColor: voucher.paymentType?.ColorPlate?.backgroundColor || '',
                }));
                setData(paymentVoucherData);
                setNewShippingId(newShippingId);

            } else {
                setError('No payment vouchers found');
            }
        } catch (error) {
            setError('Error fetching payment vouchers');
            console.error('Error fetching payment vouchers', error);
        } finally {
            setLoading(false);
        }
    };
    if (!shipmentDetails) {
        return <p>  <CustomLoader open={shipmentLoading} /> </p>;
    }

    const handleDelete = async (paymentVoucherId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_IMPORT_PAYMENT_VOUCHER(paymentVoucherId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                fetchButtonList();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const PaymentVoucherCardColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center',
            },
        },

        {
            id: 'voucherNo', label: 'Voucher No.', accessor: 'voucherNo', styleAccessor: {
                textAlign: 'center',
            },
        },

        { id: 'supplierName', label: 'Supplier / Party Ledger Name', accessor: 'supplierName' },
        { id: 'paymentToName', label: 'Payment To', accessor: 'paymentToName' },

        { id: 'currency', label: 'Currency', accessor: 'currency' },
        {
            id: 'amount1', label: 'Amount', accessor: 'amount1', styleAccessor: {
                textAlign: 'right',
            },
        },
        { id: 'baseCurrency', label: 'Base Currency', accessor: 'baseCurrency' },
        {
            id: 'conversionRate', label: 'conversion Rate', accessor: 'conversionRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'amount2', label: 'Amount in Base Currency', accessor: 'amount2', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'bankCharges', label: 'Bank Charges', accessor: 'bankCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.sn)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.sn)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.sn)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];


    const handleUpdateClick = (id) => {
        setPaymentVoucherId(id);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setPaymentVoucherId('');
    };


    const handleOpenView = (id) => {
        setPaymentVoucherId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setPaymentVoucherId('');
    };

    const handleViewClick = (id) => {
        handleOpenView(id);
    };

    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const baseCurrencySymbol = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const baseCurrencyId = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
    const currencyId = shipmentDetails.currencyId;
    const userId = shipmentDetails.userId;
    const companyId = shipmentDetails.companyId;



    return (
        <>
            <div>

                <CustomLoader open={loading} />
                <DetailsPageCard
                    Icon={PaymentOutlinedIcon}
                    columns={PaymentVoucherCardColumns}
                    title={'Payment Voucher'}
                    buttonTitle={'Create Payment Voucher'}
                    handleOpen={handleOpen}
                    data={data}
                    loading={loading}
                    error={error}
                />
                <CustomModal open={modal}  >
                    <CreatePayment
                        fetchData={fetchData}
                        clientCompanyId={customerName}
                        currencyList={currencyList}
                        paymentType={paymentType}
                        commanShipmentId={getCommanExportShipmentId}
                        setMessage={setMessage}
                        handleClose={handleClose}
                        newShippingId={newShippingId}
                        shipmentId={shipmentId}
                        baseCurrencySymbol={baseCurrencySymbol}
                        currencySymbol={currencySymbol}
                        baseCurrencyId={baseCurrencyId}
                        currencyId={currencyId}
                        shipmentOrgId={shipmentOrgId}
                        fetchButtonList={fetchButtonList}
                        proformaInvoiceList={proformaInvoiceList}
                        commercialInvoiceList={commercialInvoiceList}
                        userId={userId}
                        companyId={companyId}
                        paymentToList={paymentToList}
                        partyLedger={partyLedger}
                        customerList={customerList}

                    />
                </CustomModal>

                <CustomModal open={updateModal}  >
                    <UpdatePayment
                        fetchData={fetchData}
                        currencyList={currencyList}
                        paymentType={paymentType}
                        setMessage={setMessage}
                        handleClose={handleCloseUpdate}
                        paymentVoucherId={paymentVoucherId}
                        proformaInvoiceList={proformaInvoiceList}
                        commercialInvoiceList={commercialInvoiceList}
                        paymentToList={paymentToList}
                        partyLedger={partyLedger}
                        customerList={customerList}

                    />
                </CustomModal>
                <CustomModal
                    open={viewModal}
                    modalStyles={{
                        maxHeight: '70vh',
                        top: "10%",
                    }}
                    handleClose={handleCloseView}>
                    <PaymentVoucherView
                        handleClose={handleCloseView}
                        fetchData={fetchData}
                        currencyList={currencyList}
                        paymentType={paymentType}
                        setMessage={setMessage}
                        paymentVoucherId={paymentVoucherId}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomDelete
                    handleDelete={handleDelete}
                    open={deleteAlert}
                    rowId={rowId}
                    handleClose={() => setDeleteAlert(false)}
                />
            </div>
        </>
    );
}
